import { grouped, VIDEO_DEFAULT_RESOLUTION } from "@/entities/scene-card/model/creditRates";
import { SKU, type PriceBook } from "@/entities/pricing/model/priceBook";

import type { VideoResolution } from "../api/videoService";
import {
  DEFAULT_REAL_PERSON_MODEL,
  REAL_PERSON_DEFAULT_DURATION_SEC,
  realPersonBillingModelCode,
  realPersonModelTier,
  realPersonVariantSuffix,
} from "./realPersonModelTiers";

/**
 * 视频 hub「真人出镜」大卡的价签(B2 #9,0927 K4 实测)。
 *
 * ★此前这张卡借用「自由创作」那句「5 秒 720P 约 565 积分(含 1 张台本图)」—— 真人出镜页落地默认是
 *   满血 2.0 · 720P · 15 秒 · 只带定妆照(novin),跟 5 秒直发不是一回事。
 * ★数全部同源:默认档 / 秒数取 `realPersonModelTiers`(页面 initialForm 也读它们),计费 model_code
 *   与规格档后缀走与页面报价**同一组**函数(`realPersonBillingModelCode` / `realPersonVariantSuffix`),
 *   单价从价目表 `variantByModel` 反查 —— 前端不拼 variant key、不写价。
 * ★价目表没到货 / 查不到该规格 → 空串(卡面出骨架),不编数。
 * ★`unit × 秒` 用的是目录里的**单位单价**(整数,不足 1 分向上取整),与页面用 dryRun 报价的总额可能差
 *   零点几个积分 —— 卡面标「约」,总额以页内报价为准(api PricingCatalogService 头注的取舍)。
 */
export function realPersonDefaultCostLabel(b: PriceBook): string {
  const resolution = VIDEO_DEFAULT_RESOLUTION as VideoResolution;
  const hasVideoInput = false; // 默认身份参考 = 定妆照(identityRefMode "photo")
  const variant = b.variantByModel(
    SKU.video,
    realPersonBillingModelCode(DEFAULT_REAL_PERSON_MODEL, resolution, hasVideoInput),
    realPersonVariantSuffix(resolution, hasVideoInput)
  );
  const unit = variant ? b.unit(SKU.video, variant) : null;
  if (unit == null) return "";
  const tier = realPersonModelTier(DEFAULT_REAL_PERSON_MODEL);
  return `默认档 ${REAL_PERSON_DEFAULT_DURATION_SEC} 秒 ${resolution.toUpperCase()} 约 ${grouped(unit * REAL_PERSON_DEFAULT_DURATION_SEC)} 积分(${tier.label},不含身份视频)`;
}
